module.exports = __webpack_public_path__ + "img/38e1462.png";